import { useEffect, useState } from 'react';
import { Button, Card, Heading } from '../../components/ui/index';
import { PageTitle } from '../../components/layout/PageTitle';

const getApiBaseUrl = (): string => {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return '/api';

  const firstDot = host.indexOf('.');
  const apiHost = firstDot > 0 ? `${host.substring(0, firstDot)}.api.${host.substring(firstDot + 1)}` : host;
  return `${window.location.protocol}//${apiHost}`;
};

const API_BASE = getApiBaseUrl();

interface ConnectivityResult {
  tenantSlug: string;
  database: string;
  dbTimestamp: string;
  dbVersion: string;
  apiTimestamp: string;
  status: string;
  error?: string;
}

const ConnectivityCard = () => {
  const [result, setResult] = useState<ConnectivityResult | null>(null);
  const [loading, setLoading] = useState(false);

  const checkConnectivity = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/Connectivity`);
      const data = await res.json() as ConnectivityResult;
      setResult(data);
    } catch (error) {
      setResult({ status: 'disconnected', error: String(error), tenantSlug: '', database: '', dbTimestamp: '', dbVersion: '', apiTimestamp: '' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void checkConnectivity();
  }, []);

  const statusTone = result?.status === 'connected' ? 'bg-positive' : 'bg-critical';

  return (
    <Card header={<Heading level={3}>Database Connectivity</Heading>} footer={<Button variant="secondary" onClick={() => void checkConnectivity()}>Refresh</Button>}>
      {loading && <p>Checking...</p>}
      {result?.status === 'connected' && (
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <span className={`inline-block size-2 rounded-full ${statusTone}`} />
            <p className="m-0"><strong>Connected</strong> - UI to API to Tenant DB</p>
          </div>
          <p className="m-0 text-sm text-neutral-secondary-foreground">Tenant: {result.tenantSlug} - DB: {result.database}</p>
          <p className="m-0 text-sm text-neutral-secondary-foreground">DB Time: {new Date(result.dbTimestamp).toLocaleString()}</p>
          <p className="m-0 text-sm text-neutral-secondary-foreground">DB Version: {result.dbVersion}</p>
          <p className="m-0 text-sm text-neutral-secondary-foreground">API Time: {new Date(result.apiTimestamp).toLocaleString()}</p>
        </div>
      )}
      {result?.status === 'disconnected' && (
        <div className="flex items-center gap-2">
          <span className={`inline-block size-2 rounded-full ${statusTone}`} />
          <p className="m-0"><strong>Disconnected</strong> - {result.error}</p>
        </div>
      )}
    </Card>
  );
};

const DashboardPage = () => {
  return (
    <>
      <PageTitle title="Dashboard" />
      <ConnectivityCard />
    </>
  );
};

export default DashboardPage;
